<page-load-header *ngIf="!initialized"></page-load-header>
<form class="form" (ngSubmit)="onSave()" #myForm="ngForm" novalidate>
  <div *ngIf="initialized" class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">CE Evaluation</h5>
    </div>

    <div class="modal-body p-0">
      <div class="p-2"><h5>{{eventTitle}}</h5>
      </div>
      <div *ngIf="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>

      <survey [model]="surveyModel"></survey>


      <div *ngIf="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-md-12">
          <button class="btn btn-sm btn-outline-dark" (click)="modal.dismiss('Cross click')" [promiseBtn]="submitComplete" type="button">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</form>
